import { render, staticRenderFns } from "./GroupChart.vue?vue&type=template&id=799554a9&scoped=true&"
import script from "./GroupChart.vue?vue&type=script&lang=js&"
export * from "./GroupChart.vue?vue&type=script&lang=js&"
import style0 from "./GroupChart.vue?vue&type=style&index=0&id=799554a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799554a9",
  null
  
)

export default component.exports